import styled from "styled-components";
import { LoadingIcon } from "../../atoms/icons/LoadingIcon";

export const FileUploading: React.FC = () => {
  return (
    <StyledResultValue>
      転送中
      <LoadingIcon />
    </StyledResultValue>
  );
};

const StyledResultValue = styled.div`
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;
